import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { config } from "../../config";
import Header from "../../components/hotels/Header";

function HotelsSearchBooking() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [bookingRef, setBookingRef] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // Auto-fill booking reference from URL if present
  useEffect(() => {
    const refFromUrl = searchParams.get("ref");
    if (refFromUrl) {
      setBookingRef(refFromUrl);
      handleSearch(refFromUrl);
    }
  }, [searchParams]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearch = async (ref = bookingRef) => {
    if (!ref) {
      setError("Please enter a booking reference");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      console.log("🔍 Searching for booking reference:", ref);

      // Search for hotel booking
      const hotelResponse = await fetch(
        `${config.backendServer}/api/stays/bookings/${ref}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Search for flight booking
      const flightResponse = await fetch(
        `${config.backendServer}/api/flights/orders/${ref}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const [hotelData, flightData] = await Promise.all([
        hotelResponse.json().catch(() => null),
        flightResponse.json().catch(() => null),
      ]);

      console.log(
        `📥 Hotel Search Response (Status: ${hotelResponse.status}):`,
        hotelData
      );
      console.log(
        `📥 Flight Search Response (Status: ${flightResponse.status}):`,
        flightData
      );

      // Check if either booking was found
      if (hotelResponse.ok) {
        console.log("✅ Hotel booking found successfully!");
        navigate("/hotels/confirmation", {
          state: { booking: hotelData },
        });
        return;
      }

      if (flightResponse.ok) {
        console.log("✅ Flight booking found successfully!");
        navigate("/flights/confirmation", {
          state: { order: flightData },
        });
        return;
      }

      // If neither booking was found
      throw new Error("No booking found with this reference");
    } catch (error) {
      console.error("❌ Search Error:", error);
      setError("Booking not found. Please check your reference number.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-lg mx-auto">
          <h1 className="text-3xl font-bold mb-4">Find your booking</h1>
          <p className="text-gray-600 mb-8">
            Enter your booking reference to view your reservation details
          </p>

          <div className="space-y-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Booking reference (e.g., NUYBFX)"
                value={bookingRef}
                onChange={(e) => setBookingRef(e.target.value.toUpperCase())}
                className="w-full p-4 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            {error && <p className="text-red-500 text-sm">{error}</p>}

            <button
              onClick={() => handleSearch()}
              disabled={isLoading}
              className={`w-full ${config.primaryColorBg} text-gray-800 py-4 rounded-full hover:bg-purple-700 transition-colors text-lg font-semibold disabled:bg-purple-300`}
            >
              {isLoading ? "Searching..." : "Search"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HotelsSearchBooking;
